import HTMLReactParser from 'html-react-parser';
import { resolveImageReferenceToImage } from './imageResolver';
import { type LocationCardProps } from '4-sections/FilteredListings/MapAndListing/LocationCard';
import type { ImageProps } from '2-core-elements/Image/Image';
// import { getApiHostname } from 'cms/constants';

export type LocationPage = {
    title?: string;
    physicalLocation?: string;
    phoneNumber?: string;
    url?: string;
    image: {
        url: string;
        altText: string;
    };
    latitude?: number;
    longitude?: number;
    totalItems?: number;
};
export type LocationPageItems = LocationPage[];

export interface LocationCardResolverSettings {
    emailLabel: string;
    telLabel: string;
}

export interface GenerateDescriptionProps {
    physicalLocation?: string | null;
    EmailAddress?: string | null;
    phoneNumber?: string | null;
    emailLabel?: string;
    telLabel?: string;
    hasHeading?: boolean;
}

export const generateDescription = ({ physicalLocation, phoneNumber, telLabel = 'tel', hasHeading = false }: GenerateDescriptionProps): string => {
    const telNumber = phoneNumber ? `${telLabel ? `<span>${telLabel}:</span> ` : ''}<a href="${telLabel}:${phoneNumber.replace(/\s+/g, '')}">${phoneNumber}</a><br />` : '';
    // const emailAddress = EmailAddress ? `${emailLabel ? `<span>${emailLabel}:</span> ` : ''}<span>${EmailAddress}</span>` : '';
    const contact = telNumber ? `${telNumber}` : '';
    const addressHeading = hasHeading ? '<h4>Address</h4>' : '';
    const phoneHeading = hasHeading ? '<h4>Phone number</h4>' : '';
    return `<div class="card-description-address">${addressHeading}${physicalLocation}</div><div class="card-description-contact">${phoneHeading}${contact}</div>`;
};


export const resolveLocationPagesToLocationCards = (items: LocationPageItems): LocationCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { title, physicalLocation, phoneNumber, url, image } = item as NonNullable<typeof item>;
        const img = resolveImageReferenceToImage(`${image.url}`) as ImageProps;
        const description = generateDescription({ physicalLocation, phoneNumber });

        return {
            ...(url && { link: { href: url } }),
            title: title as string,
            ...(physicalLocation && { children: HTMLReactParser(description as string) }),
            img,
        };
    });
};
